// extracted by mini-css-extract-plugin
export default {"image":"Mainscreen_image__Qsf9Y"};